export default "__VITE_ASSET__edd8aim$__"